import { Box } from '@material-ui/core';
import React from 'react';

import { formatPhoneReadable, parsePhone } from '../../../../helpers/helpers';
import { ReactComponent as PersonIcon } from '../../../shared/assets/icons/person.svg';
import { ReactComponent as TableIcon } from '../../../shared/assets/icons/table.svg';
import { toTzMoment } from '../../../shared/lib';
import { getReservePersonName, tableColors } from '../lib';
import { Duo } from './duo';
import { SvgIcon } from './svgIcon';
import { Tag } from './tag';

export const ReserveInfo: React.FC<{
  reserve: GM.ReservesSchemas.ScheduleReserve;
  restaurantTz?: string;
  state: GM.ReservesSchemas.TableStateV2;
}> = ({ reserve, restaurantTz, state }) => {
  let phone: string | null = null;
  if (reserve.phone) {
    const phoneParsed = parsePhone(reserve.phone);
    if (phoneParsed) {
      phone = formatPhoneReadable(phoneParsed);
    }
  }

  const person = getReservePersonName(reserve) || 'Гость';
  const date = toTzMoment(reserve.date, restaurantTz);
  const timeStr = date.format('HH:mm');
  const room = reserve.tables[0].hall;

  const infoStyles: React.CSSProperties = {
    color: tableColors[state].head.color,
    background: tableColors[state].head.bg,
  };

  if (tableColors[state].head.stripe) {
    infoStyles['fontWeight'] = 600;
    infoStyles['background'] = `repeating-linear-gradient(
      -45deg,
      ${tableColors[state].head.stripe} 0 4px,
      transparent 4px 8px
    ), ${infoStyles.background}`;
  }

  return (
    <Box
      marginTop="16px"
      borderRadius={8}
      border="1px solid #EEF0F2"
      padding="24px"
      fontSize={14}
      // fontWeight={500}
    >
      <Box
        mb="24px"
        display="flex"
        gridColumnGap={16}
        gridRowGap={8}
        alignItems="center"
        flexDirection="row"
        flexWrap="wrap"
      >
        <Box flexGrow={1}>
          <Tag style={infoStyles}>
            <span style={{ fontWeight: 500 }}>{timeStr}</span>{' '}
            <span style={{ fontWeight: 400 }}>{date.format('D MMMM YYYY')}</span>
          </Tag>
        </Box>
        <Box flexGrow={1}>
          <Duo
            first={<SvgIcon icon={TableIcon} width={18} height={18} />}
            second={
              <Box fontSize={14} fontWeight={500} style={{ whiteSpace: 'nowrap' }}>
                {room}
              </Box>
            }
            gridColumnGap={4}
          />
        </Box>
        <Box flexGrow={1}>
          <Duo
            first={<SvgIcon icon={PersonIcon} width={18} height={18} />}
            second={
              <Box fontSize={14} fontWeight={500} style={{ whiteSpace: 'nowrap' }}>
                {reserve.persons} человек
              </Box>
            }
            gridColumnGap={4}
          />
        </Box>
      </Box>

      {person && (
        <Box fontSize={16} fontWeight={600}>
          {person}
        </Box>
      )}

      {phone && (
        <Box fontSize={14} fontWeight={400} marginTop="4px">
          {phone}
        </Box>
      )}
    </Box>
  );
};
